// GraphQL error codes surfaced via `extensions: { code: ... }` on
// `GraphQL::ExecutionError`. Shared so the raise site (Rails) and the detect
// sites (Apollo error link, mutation catch helper) agree on the wire value.

export const READ_ONLY_ADMIN_WRITE_DENIED_CODE = 'READ_ONLY_ADMIN_WRITE_DENIED';
export const ESTIMATED_AUM_REQUIRED_CODE = 'ESTIMATED_AUM_REQUIRED';
// `Mutations::Concerns::ProfessionalNetworkAccess`, raised by the referral and professional-service
// mutations. The refused message is advisor-facing copy.
export const PROFESSIONAL_NETWORK_ACCESS_DENIED_CODE = 'PROFESSIONAL_NETWORK_ACCESS_DENIED';
export const PROFESSIONAL_NETWORK_WRITE_REFUSED_CODE = 'PROFESSIONAL_NETWORK_WRITE_REFUSED';
export const PROFESSIONAL_CONTACT_ACCESS_DENIED_CODE = 'PROFESSIONAL_CONTACT_ACCESS_DENIED';
export const PLAN_CREATION_RECONCILIATION_REQUIRED_CODE = 'PLAN_CREATION_RECONCILIATION_REQUIRED';
export const PLAN_CREATION_VENDOR_REJECTED_CODE = 'PLAN_CREATION_VENDOR_REJECTED';
export const PLAN_IMPORT_SOURCE_LIMIT_CODE = 'PLAN_IMPORT_SOURCE_LIMIT';
export const PLAN_IMPORT_REFUSED_CODE = 'PLAN_IMPORT_REFUSED';
export const PLAN_UPDATING_CODE = 'PLAN_UPDATING';
export const PLAN_REVISION_STALE_CODE = 'PLAN_REVISION_STALE';
// `Mutations::CreateHouseholdReferral::REFUSED_CODE`; its message is advisor-facing copy.
export const HOUSEHOLD_REFERRAL_REFUSED_CODE = 'HOUSEHOLD_REFERRAL_REFUSED';

// The occurrence-scoped mutations (4C1T-623). Each message is written to be shown to the
// advisor as-is, so the client surfaces the server's copy rather than a generic fallback.
// Raised from `ServiceCatalog::OccurrenceLookup::STALE_CODE` / `RESOLVED_CODE` and
// `Mutations::ServiceCatalog::ResendServiceOccurrenceReminder#refusal`.
export const OCCURRENCE_STALE_CODE = 'OCCURRENCE_STALE';
export const OCCURRENCE_ALREADY_RESOLVED_CODE = 'OCCURRENCE_ALREADY_RESOLVED';
export const OCCURRENCE_NOT_SENDABLE_CODE = 'OCCURRENCE_NOT_SENDABLE';
export const OCCURRENCE_NOT_RESCHEDULABLE_CODE = 'OCCURRENCE_NOT_RESCHEDULABLE';
export const OCCURRENCE_DATE_TAKEN_CODE = 'OCCURRENCE_DATE_TAKEN';
// Partial success, not a failure: the occurrence HAS moved to its new date and the row is marked
// failed; only the invite did not go out. A client showing the old date after this is lying about
// committed state, so it must refetch as well as report (`reschedule_occurrence.rb:238-241`).
export const OCCURRENCE_MOVED_BUT_SEND_FAILED_CODE = 'OCCURRENCE_MOVED_BUT_SEND_FAILED';

// Planning failures, raised through `PlanningErrorPresenter`. The code says who to chase: the
// advisor's own input, our persistence, or the engine. Rails writes every message for an advisor
// and keeps Conquest's own text in its log.
export const PLAN_VALIDATION_FAILED_CODE = 'PLAN_VALIDATION_FAILED';
export const PLAN_LOCAL_FAILED_CODE = 'PLAN_LOCAL_FAILED';
export const PLAN_ENGINE_FAILED_CODE = 'PLAN_ENGINE_FAILED';

// Partial success on the `plan` query, not a failure: `data.plan` is still set, but it is the plan the
// planning engine has now, because the engine refused or didn't confirm the latest saved draft.
export const PLAN_SYNC_FAILED_CODE = 'PLAN_SYNC_FAILED';

// `Mutations::RespondToSurvey::UNAVAILABLE_CODE`: the survey was removed from its round while the advisor had it open.
export const SURVEY_UNAVAILABLE_CODE = 'SURVEY_UNAVAILABLE';
